import React from "react";
import { useNavigate } from "react-router-dom";
import { connect } from 'react-redux';
function SmartWatch(){
    const navigate = useNavigate();
    return(
        <div>
            Live View Alert
            <div className="cursor-pointer" onClick={() => navigate('/live')} style={{border: '1px solid red'}}>Smart lock</div>
        </div>
    )
}

export default connect((store) => {
    return {
      token: store.tokenReducer,
      control: store.controlReducer,
    }
  })(SmartWatch)